var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 306,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.457,
    d: "M371.622 114c-24-38.5-48.89-26-102-17-53.109 9-131.5-94.5-208.39-26-30.36 27.047-5.835 92.817-13.59 113.5-8.264 22.045-43.175 36.808-46.765 62-4.309 30.237 32.983 59.12 55.11 58.975C70.07 305.383 149.621 280 181.621 277s33.476 15.546 65.559 20.339C427 322 351 232 352.5 201s43.122-48.5 19.122-87Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.867 50.751a.484.484 0 0 1-.324-.842c.484-.435.991-.86 1.501-1.264a.482.482 0 1 1 .596.76c-.496.391-.984.802-1.455 1.222a.49.49 0 0 1-.322.124h.004ZM155.038 69.126a.48.48 0 0 1-.478-.422 29.107 29.107 0 0 0-.744-3.835.482.482 0 1 1 .933-.246c.344 1.3.604 2.632.769 3.96a.485.485 0 0 1-.42.54c-.02.003-.04.005-.06.005v-.002Zm-3.07-9.913a.484.484 0 0 1-.431-.262 28.864 28.864 0 0 0-2.015-3.345.482.482 0 1 1 .793-.554 30.125 30.125 0 0 1 2.081 3.457.483.483 0 0 1-.428.704Zm-6.292-8.248a.487.487 0 0 1-.326-.127 29.403 29.403 0 0 0-3.048-2.439.482.482 0 1 1 .553-.793 30.255 30.255 0 0 1 3.15 2.52.481.481 0 0 1-.326.837l-.003.002Zm-32.858-4.863a.483.483 0 0 1-.209-.917 30.3 30.3 0 0 1 3.746-1.502.483.483 0 0 1 .3.92 29.252 29.252 0 0 0-3.626 1.454.464.464 0 0 1-.209.047l-.002-.002Zm24.101-.7a.484.484 0 0 1-.184-.035 29.015 29.015 0 0 0-3.703-1.242.48.48 0 0 1-.345-.589.484.484 0 0 1 .591-.344 30.26 30.26 0 0 1 3.826 1.284.484.484 0 0 1-.185.93v-.004Zm-14.109-2.097a.483.483 0 0 1-.046-.962 30.245 30.245 0 0 1 4.036-.118.483.483 0 0 1 .464.502.47.47 0 0 1-.502.465 29.006 29.006 0 0 0-3.905.113l-.047.002v-.002ZM154.883 77.51c-.027 0-.051 0-.078-.007a.485.485 0 0 1-.4-.555c.103-.625.182-1.258.245-1.884a.484.484 0 0 1 .962.091 31.35 31.35 0 0 1-.251 1.946.484.484 0 0 1-.476.406l-.002.003ZM141.931 97.516a.482.482 0 0 1-.267-.886 28.873 28.873 0 0 0 1.553-1.095.485.485 0 0 1 .678.093.487.487 0 0 1-.094.678 29.52 29.52 0 0 1-1.604 1.13.483.483 0 0 1-.264.08h-.002ZM125.663 102.393c-1.116 0-2.242-.062-3.348-.189a.486.486 0 0 1-.427-.535.487.487 0 0 1 .533-.427c1.269.144 2.553.202 3.839.176a.478.478 0 0 1 .493.473.485.485 0 0 1-.473.493 31.95 31.95 0 0 1-.62.007l.003.002Zm6.895-.82a.483.483 0 0 1-.113-.951 29.23 29.23 0 0 0 3.668-1.144.484.484 0 0 1 .346.902 30.642 30.642 0 0 1-3.79 1.182.484.484 0 0 1-.113.013l.002-.002Zm-16.375-.742a.556.556 0 0 1-.155-.024 30.3 30.3 0 0 1-3.668-1.515.483.483 0 1 1 .427-.867 29.225 29.225 0 0 0 3.55 1.466.482.482 0 0 1-.156.942l.002-.002Zm-8.966-4.88a.48.48 0 0 1-.3-.105 30.127 30.127 0 0 1-2.936-2.668.481.481 0 1 1 .695-.669 29.025 29.025 0 0 0 2.841 2.582.483.483 0 0 1-.3.862v-.003Zm-6.771-7.636a.481.481 0 0 1-.411-.231 30.548 30.548 0 0 1-1.85-3.51.482.482 0 1 1 .882-.393 29.224 29.224 0 0 0 1.792 3.396.483.483 0 0 1-.411.736l-.002.002Zm-3.779-9.484a.484.484 0 0 1-.473-.384 29.733 29.733 0 0 1-.555-3.93.483.483 0 0 1 .446-.517.477.477 0 0 1 .518.446c.096 1.273.275 2.553.538 3.803a.482.482 0 0 1-.474.582ZM96.34 68.608c-.022 0-.046 0-.069-.005a.48.48 0 0 1-.408-.546c.093-.644.206-1.295.342-1.933a.484.484 0 0 1 .946.2 28.108 28.108 0 0 0-.33 1.87.483.483 0 0 1-.478.416l-.003-.002ZM104.16 64.862a.356.356 0 0 0 .073.407l3.099 3.017a18.92 18.92 0 0 0-.291 6.096l-3.367 2.71a.357.357 0 0 0-.112.398l1.758 4.88a.355.355 0 0 0 .34.236l4.32-.058a18.867 18.867 0 0 0 4.108 4.514l-.467 4.299a.357.357 0 0 0 .203.36l4.694 2.208c.137.064.3.035.406-.074l3.017-3.099c1.975.42 4.032.53 6.096.291l2.71 3.368a.358.358 0 0 0 .398.111l4.88-1.757a.355.355 0 0 0 .236-.34l-.058-4.32A18.858 18.858 0 0 0 140.717 84l4.299.466a.356.356 0 0 0 .36-.202l2.208-4.694a.356.356 0 0 0-.073-.406l-3.099-3.017c.42-1.975.528-4.032.291-6.096l3.368-2.708a.358.358 0 0 0 .111-.398l-1.758-4.88a.355.355 0 0 0-.34-.236l-4.32.058a18.866 18.866 0 0 0-4.108-4.514l.467-4.299a.357.357 0 0 0-.203-.36l-4.694-2.208a.355.355 0 0 0-.406.073l-3.017 3.1a18.903 18.903 0 0 0-6.096-.292l-2.71-3.368a.358.358 0 0 0-.398-.11l-4.88 1.757a.355.355 0 0 0-.236.34l.058 4.32a18.862 18.862 0 0 0-4.514 4.108l-4.299-.467a.356.356 0 0 0-.36.202l-2.208 4.695v-.003Z",
    fill: "#2269A7",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.875 77.199a4.98 4.98 0 0 1-4.136-2.2 4.94 4.94 0 0 1-.758-3.736 4.955 4.955 0 0 1 2.106-3.18 4.982 4.982 0 0 1 6.916 1.348 4.989 4.989 0 0 1-1.349 6.917 4.964 4.964 0 0 1-2.779.85Zm-.009-9.213c-.842 0-1.657.249-2.359.722a4.19 4.19 0 0 0-1.788 2.7 4.204 4.204 0 0 0 .644 3.171 4.226 4.226 0 0 0 5.871 1.147 4.237 4.237 0 0 0 1.147-5.872 4.232 4.232 0 0 0-3.513-1.868h-.002Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.976 85.15c-5.399 0-10.259-3.404-12.112-8.476a.017.017 0 0 0-.004-.009c0-.002 0-.004-.003-.006a.13.13 0 0 0-.009-.025l-.004-.013a12.977 12.977 0 0 1-.651-2.666c-.002-.018-.002-.033-.002-.05 0-.188.138-.347.326-.374a.375.375 0 0 1 .423.322c.113.85.319 1.695.613 2.51v.007c0 .002 0 .004.002.007l.011.03c1.742 4.78 6.32 7.99 11.408 7.99 1.364 0 2.712-.232 4.009-.685l.1-.035a12.173 12.173 0 0 0 8.033-11.424c0-1.399-.242-2.783-.719-4.112 0-.004-.003-.006-.005-.01 0-.005-.002-.007-.004-.012a12.178 12.178 0 0 0-11.417-8.01c-1.39 0-2.766.24-4.087.713-.005 0-.007.002-.011.004-.005 0-.007.002-.012.005a12.12 12.12 0 0 0-5.282 3.73.375.375 0 1 1-.582-.476 12.87 12.87 0 0 1 5.611-3.96 12.846 12.846 0 0 1 4.366-.764 12.928 12.928 0 0 1 12.12 8.503v.004c.515 1.433.773 2.904.773 4.39a12.925 12.925 0 0 1-8.53 12.13l-.136.048h-.004a12.836 12.836 0 0 1-4.223.716l.002-.003Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.665 99.958a.482.482 0 0 1-.322-.842c.493-.442 1.01-.862 1.537-1.247a.483.483 0 1 1 .571.78 18.5 18.5 0 0 0-1.462 1.186.485.485 0 0 1-.322.125l-.002-.002ZM101.215 109.632a.485.485 0 0 1-.469-.366 19.463 19.463 0 0 0-1.157-3.299.483.483 0 0 1 .877-.402 20.413 20.413 0 0 1 1.217 3.468.483.483 0 0 1-.468.602v-.003Zm-4.379-8.239a.485.485 0 0 1-.36-.16 18.828 18.828 0 0 0-2.572-2.366.485.485 0 0 1-.094-.678.484.484 0 0 1 .678-.09 19.68 19.68 0 0 1 2.706 2.485.484.484 0 0 1-.358.807v.002Zm-7.742-5.207a.466.466 0 0 1-.164-.03 18.71 18.71 0 0 0-3.384-.881.483.483 0 0 1-.397-.556.482.482 0 0 1 .555-.4c1.209.198 2.406.511 3.557.93a.483.483 0 0 1-.165.937h-.002Zm-12.767-.125a.483.483 0 0 1-.158-.94 19.708 19.708 0 0 1 3.575-.86.484.484 0 0 1 .138.958 18.8 18.8 0 0 0-3.4.818.476.476 0 0 1-.155.026v-.002ZM101.542 117.359c-.027 0-.051 0-.078-.007a.485.485 0 0 1-.4-.555c.1-.618.171-1.249.209-1.871a.495.495 0 0 1 .511-.453.483.483 0 0 1 .453.511 19.45 19.45 0 0 1-.22 1.968.483.483 0 0 1-.475.407ZM92.546 130.73a.484.484 0 0 1-.251-.897c.536-.325 1.06-.68 1.558-1.058a.482.482 0 0 1 .677.094.486.486 0 0 1-.093.677c-.524.395-1.075.771-1.64 1.113a.485.485 0 0 1-.25.071ZM83.792 133.498a.483.483 0 0 1-.031-.964 18.853 18.853 0 0 0 3.395-.54.483.483 0 0 1 .237.936 19.847 19.847 0 0 1-3.57.568h-.033.002Zm-5.694-.48a.487.487 0 0 1-.113-.013 19.746 19.746 0 0 1-3.423-1.153.483.483 0 1 1 .391-.884c1.048.464 2.143.833 3.256 1.097a.483.483 0 0 1-.11.953Zm-8.17-4.181a.475.475 0 0 1-.316-.117 19.814 19.814 0 0 1-2.503-2.604.484.484 0 1 1 .755-.604 18.862 18.862 0 0 0 2.38 2.475.483.483 0 0 1-.319.848l.003.002Zm-5.3-7.486a.48.48 0 0 1-.45-.307 19.91 19.91 0 0 1-1.017-3.467.483.483 0 1 1 .948-.185c.22 1.12.545 2.228.967 3.299a.484.484 0 0 1-.449.66ZM63.387 112.241c-.018 0-.035 0-.051-.003a.484.484 0 0 1-.429-.533c.071-.653.176-1.313.311-1.955a.484.484 0 0 1 .947.2 18.732 18.732 0 0 0-.296 1.86.484.484 0 0 1-.48.431h-.002ZM68.555 108.966a.23.23 0 0 0 .05.264l2.014 1.962a12.262 12.262 0 0 0-.189 3.965l-2.19 1.762a.23.23 0 0 0-.073.258l1.142 3.174a.232.232 0 0 0 .22.154l2.81-.038a12.22 12.22 0 0 0 2.672 2.934l-.302 2.797a.232.232 0 0 0 .131.234l3.052 1.437a.232.232 0 0 0 .265-.049l1.962-2.015c1.284.273 2.62.344 3.965.189l1.761 2.19a.23.23 0 0 0 .258.074l3.175-1.142a.233.233 0 0 0 .153-.22l-.038-2.81a12.238 12.238 0 0 0 2.935-2.673l2.797.302a.23.23 0 0 0 .233-.131l1.437-3.052a.232.232 0 0 0-.049-.265l-2.014-1.961a12.27 12.27 0 0 0 .188-3.966l2.19-1.761a.23.23 0 0 0 .074-.258l-1.142-3.174a.232.232 0 0 0-.22-.154l-2.81.038a12.242 12.242 0 0 0-2.672-2.935l.302-2.796a.232.232 0 0 0-.131-.234l-3.053-1.437a.231.231 0 0 0-.264.049l-1.962 2.015a12.259 12.259 0 0 0-3.965-.189l-1.762-2.19a.23.23 0 0 0-.257-.074l-3.175 1.142a.232.232 0 0 0-.153.22l.038 2.81a12.238 12.238 0 0 0-2.935 2.673l-2.797-.302a.229.229 0 0 0-.233.131l-1.438 3.052Z",
    fill: "#2269A7",
    fillOpacity: 0.15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.678 116.985a3.24 3.24 0 1 1-.006-6.48 3.24 3.24 0 0 1 .006 6.48Zm-.004-5.991c-.547 0-1.078.162-1.533.469a2.742 2.742 0 0 0-1.164 1.755 2.75 2.75 0 0 0 4.234 2.81 2.754 2.754 0 0 0-1.54-5.034h.002Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.743 122.157a8.406 8.406 0 0 1-7.876-5.511v-.011c0-.005-.004-.012-.006-.016l-.003-.009a8.555 8.555 0 0 1-.424-1.735v-.033c0-.12.089-.227.211-.242a.243.243 0 0 1 .276.208c.073.554.208 1.102.4 1.633V116.45l.006.02a7.917 7.917 0 0 0 7.418 5.194c.886 0 1.764-.149 2.608-.444.022-.007.044-.016.067-.022a7.918 7.918 0 0 0 5.222-7.429c0-.911-.157-1.811-.468-2.675 0-.002 0-.004-.003-.007 0-.002 0-.004-.002-.006a7.919 7.919 0 0 0-7.424-5.21c-.904 0-1.8.156-2.66.465-.002 0-.004 0-.006.002-.002 0-.004 0-.007.002a7.873 7.873 0 0 0-3.434 2.426.246.246 0 0 1-.345.035.237.237 0 0 1-.088-.188c0-.054.017-.109.055-.154a8.401 8.401 0 0 1 3.648-2.577c.033-.013.069-.024.102-.035a8.34 8.34 0 0 1 2.737-.462 8.412 8.412 0 0 1 7.884 5.531c.336.933.502 1.889.502 2.855a8.412 8.412 0 0 1-5.636 7.92h-.002a8.367 8.367 0 0 1-2.746.464l-.006.002Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m350.454 131.136-54.651-.304c-2.237-.013-3.627 2.427-2.475 4.345l.273.457a2.871 2.871 0 0 0 2.46 1.391h54.377a2.869 2.869 0 0 0 2.869-2.869v-.152a2.867 2.867 0 0 0-2.853-2.868ZM358.089 134.069v.09a2.869 2.869 0 0 0 2.869 2.869h12.133a2.87 2.87 0 0 0 2.772-2.128 2.87 2.87 0 0 0-2.751-3.609l-12.133-.09a2.87 2.87 0 0 0-2.89 2.868ZM339.418 143.797l-41.505-.304c-2.237-.013-3.627 2.427-2.475 4.346l.274.456a2.868 2.868 0 0 0 2.459 1.391h41.231a2.87 2.87 0 0 0 2.869-2.869v-.152a2.867 2.867 0 0 0-2.853-2.868ZM347.053 146.731v.089a2.87 2.87 0 0 0 2.869 2.87h12.133a2.87 2.87 0 0 0 .021-5.737l-12.133-.09a2.869 2.869 0 0 0-2.89 2.868Z",
    fill: "#2269A7",
    fillOpacity: 0.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.664 212.296a.383.383 0 0 1-.141-.032l-.158-.097-5.502-3.849a2.125 2.125 0 0 1-.347-.307.699.699 0 0 1-.11-.404v-.437c0-.162.036-.291.11-.388.084-.108.2-.216.347-.323l5.502-3.849.158-.065a.276.276 0 0 1 .141-.048c.085 0 .158.032.221.097a.282.282 0 0 1 .095.226v1.488a.548.548 0 0 1-.126.372 1.455 1.455 0 0 1-.284.226l-3.642 2.49 3.642 2.491c.105.064.2.14.284.226.084.086.126.21.126.372v1.471a.356.356 0 0 1-.095.259.328.328 0 0 1-.221.081ZM281.422 213.832a.299.299 0 0 1-.237-.113.314.314 0 0 1-.094-.227c0-.053.01-.107.031-.161l5.361-13.195a.68.68 0 0 1 .157-.242c.084-.087.205-.13.363-.13h1.214c.095 0 .173.038.236.113.063.065.095.14.095.227a.54.54 0 0 1-.032.161l-5.376 13.195a.805.805 0 0 1-.173.243c-.074.086-.194.129-.363.129h-1.182ZM292.986 212.296a.33.33 0 0 1-.221-.081.356.356 0 0 1-.095-.259v-1.471c0-.162.042-.286.127-.372.084-.086.178-.162.283-.226l3.642-2.491-3.642-2.49a1.449 1.449 0 0 1-.283-.226.544.544 0 0 1-.127-.372v-1.488c0-.097.032-.172.095-.226a.298.298 0 0 1 .221-.097c.052 0 .105.016.157.048.053.022.1.044.142.065l5.502 3.849c.158.107.274.215.347.323a.623.623 0 0 1 .111.388v.437a.7.7 0 0 1-.111.404 1.478 1.478 0 0 1-.347.307l-5.502 3.849a1.83 1.83 0 0 1-.142.097.42.42 0 0 1-.157.032ZM363.885 122.261a.383.383 0 0 1-.141-.032l-.158-.097-5.502-3.849a2.08 2.08 0 0 1-.347-.307.697.697 0 0 1-.111-.404v-.437c0-.161.037-.291.111-.388.084-.108.2-.215.347-.323l5.502-3.849.158-.064a.269.269 0 0 1 .141-.049c.084 0 .158.033.221.097.063.054.095.13.095.227v1.487a.548.548 0 0 1-.126.372 1.498 1.498 0 0 1-.284.227l-3.642 2.49 3.642 2.49c.105.065.2.14.284.226.084.087.126.21.126.372v1.472a.354.354 0 0 1-.095.258.33.33 0 0 1-.221.081ZM368.643 123.797a.294.294 0 0 1-.237-.113.312.312 0 0 1-.094-.226c0-.054.01-.108.031-.162l5.361-13.195a.68.68 0 0 1 .157-.242c.084-.086.205-.13.363-.13h1.214c.094 0 .173.038.236.114.063.064.095.14.095.226a.552.552 0 0 1-.032.162l-5.376 13.194a.793.793 0 0 1-.173.243c-.074.086-.195.129-.363.129h-1.182ZM380.207 122.261a.33.33 0 0 1-.221-.081.354.354 0 0 1-.095-.258v-1.472c0-.162.042-.285.127-.372.084-.086.178-.161.283-.226l3.642-2.49-3.642-2.49a1.492 1.492 0 0 1-.283-.227.544.544 0 0 1-.127-.372v-1.487c0-.097.032-.173.095-.227a.302.302 0 0 1 .221-.097c.052 0 .105.016.157.049.053.021.1.043.142.064l5.502 3.849c.158.108.274.215.347.323a.625.625 0 0 1 .111.388v.437a.697.697 0 0 1-.111.404c-.073.097-.189.2-.347.307l-5.502 3.849a1.587 1.587 0 0 1-.142.097.42.42 0 0 1-.157.032Z",
    fill: "#C9D8E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.99 73.856v73.857M163.49 73.856v31.615H83.303v106.954M255.634 75.967v30.89h70.34v59.144",
    stroke: "#038FFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.583 255.872H208.77v-5.866H28.583v5.866ZM28.583 196.752h183.396v-5.624H28.583v5.624ZM28.584 151.429h181.584v-5.163H28.584v5.163Z",
    fill: "#C8D3DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.78 287.055H27.03V105.391h4.025c.95 0 1.723.797 1.723 1.779v179.885ZM213.43 300.144h-6.346V108.16c0-1.084.853-1.964 1.903-1.964h4.443v193.948Z",
    fill: "#C8D3DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.802 190.976c-2.714.053-4.943-2.203-4.943-5.005v-22.277c0-2.927 2.279-5.308 5.113-5.34 8.509-.096 26.055-.101 40.413 1.148 1.959.171 3.483 1.829 3.554 3.857l1.342 21.538c.1 2.849-2.082 5.229-4.843 5.283l-40.638.798.002-.002Z",
    fill: "#9CA6B5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m134.085 177.322 5.841.65c.817.092 1.515-.604 1.454-1.451l-1.277-17.938c-2.449-.08-4.863-.139-7.194-.18v17.566c0 .695.506 1.278 1.175 1.352l.001.001Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.478 174.212a.595.595 0 0 0 .585.572l.034-.001a.6.6 0 0 0 .553-.641l-.881-15.656-1.178-.029.887 15.754v.001Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M167.037 190.958c-2.325.046-4.234-1.888-4.234-4.288v-19.086c0-2.508 1.952-4.548 4.382-4.575 7.289-.082 22.323-.086 34.624.984 1.678.145 2.984 1.566 3.044 3.304l1.15 18.453c.085 2.441-1.784 4.48-4.148 4.527l-34.818.683v-.002Z",
    fill: "#9CA6B5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m182.704 179.259 5.004.557c.7.079 1.298-.518 1.246-1.243l-1.094-15.369a416.234 416.234 0 0 0-6.164-.154v15.05c0 .595.434 1.094 1.008 1.158v.001Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.754 176.595a.51.51 0 0 0 .502.49h.03a.515.515 0 0 0 .473-.549l-.754-13.414-1.01-.024.76 13.497h-.001Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.896 148.743c-1.674.042-3.05-1.739-3.05-3.951v-17.583c0-2.311 1.407-4.191 3.155-4.216 5.25-.075 16.078-.079 24.937.907 1.209.134 2.149 1.442 2.193 3.044l.828 16.999c.062 2.249-1.284 4.127-2.988 4.171l-25.075.629Z",
    fill: "#9CA6B5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m106.504 137.965 4.61.514c.645.072 1.196-.477 1.149-1.146l-1.008-14.158a388.285 388.285 0 0 0-5.678-.142v13.866c0 .548.399 1.008.927 1.066Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.395 135.511a.47.47 0 0 0 .462.451h.027a.474.474 0 0 0 .436-.505l-.696-12.357c-.312-.008-.62-.016-.93-.022l.7 12.435.001-.002Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M128.869 148.182c-1.945.048-3.543-2.021-3.543-4.591v-20.429c0-2.684 1.634-4.869 3.666-4.897 6.099-.089 18.679-.092 28.972 1.053 1.405.157 2.497 1.676 2.548 3.537l.962 19.751c.072 2.613-1.493 4.795-3.472 4.845l-29.134.731h.001Z",
    fill: "#9CA6B5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m144.68 135.66 5.357.596c.75.084 1.389-.554 1.333-1.331l-1.171-16.45c-2.245-.074-4.46-.127-6.597-.164v16.109c0 .636.465 1.171 1.078 1.24Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M146.877 132.809a.547.547 0 0 0 .538.524h.032a.549.549 0 0 0 .506-.588l-.807-14.357-1.081-.025.813 14.447-.001-.001Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M170.707 149.111c-1.946.048-3.543-2.021-3.543-4.591v-20.429c0-2.684 1.634-4.869 3.666-4.898 6.099-.088 18.679-.091 28.972 1.054 1.405.156 2.497 1.676 2.548 3.537l.962 19.751c.071 2.613-1.493 4.795-3.472 4.844l-29.134.732h.001Z",
    fill: "#9CA6B5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m186.519 136.588 5.357.597c.75.084 1.388-.555 1.333-1.331l-1.171-16.45c-2.246-.074-4.46-.127-6.597-.164v16.109c0 .636.465 1.171 1.078 1.239Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188.715 133.737a.547.547 0 0 0 .538.524h.032a.549.549 0 0 0 .506-.588l-.808-14.356-1.08-.026.813 14.447-.001-.001Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.04 250.681c-2.324.072-4.233-2.983-4.233-6.776v-30.154c0-3.962 1.952-7.186 4.381-7.229 7.29-.129 22.323-.136 34.624 1.555 1.679.231 2.984 2.475 3.045 5.22l1.15 29.153c.085 3.856-1.785 7.078-4.149 7.151l-34.817 1.079v.001Z",
    fill: "#9CA6B5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m93.706 222.756 5.005.557c.7.078 1.298-.519 1.245-1.243l-1.094-15.369c-2.098-.069-4.166-.12-6.163-.155v15.05c0 .595.434 1.095 1.007 1.158v.002Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.757 220.092a.509.509 0 0 0 .502.489h.03a.513.513 0 0 0 .473-.549l-.754-13.413-1.01-.025.76 13.498h-.001Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M122.72 250.372c-2.325.071-4.234-2.983-4.234-6.776v-30.154c0-3.962 1.952-7.186 4.382-7.229 7.289-.129 22.323-.136 34.624 1.555 1.678.23 2.984 2.475 3.045 5.22l1.149 29.153c.086 3.856-1.784 7.078-4.148 7.151l-34.818 1.079v.001Z",
    fill: "#9CA6B5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m138.386 222.447 5.004.557c.7.078 1.298-.519 1.245-1.243l-1.094-15.369a415.994 415.994 0 0 0-6.163-.155v15.05c0 .595.434 1.095 1.008 1.159v.001Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.438 219.783a.51.51 0 0 0 .502.49h.03a.514.514 0 0 0 .473-.55l-.754-13.413a176.45 176.45 0 0 0-1.01-.024l.76 13.497h-.001Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M167.509 250.935c-2.325.08-4.234-3.335-4.234-7.574v-33.706c0-4.429 1.952-8.032 4.381-8.081 7.29-.144 22.323-.152 34.624 1.738 1.679.258 2.984 2.767 3.045 5.836l1.15 32.588c.085 4.31-1.785 7.912-4.149 7.993l-34.817 1.207v-.001Z",
    fill: "#9CA6B5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m183.175 219.719 5.004.623c.7.087 1.298-.579 1.246-1.389l-1.094-17.179a350.669 350.669 0 0 0-6.164-.172v16.823c0 .665.434 1.224 1.008 1.295v-.001Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M185.224 216.742c.015.309.237.547.502.547l.03-.001c.278-.018.489-.293.473-.613l-.754-14.993c-.339-.01-.674-.019-1.009-.026l.759 15.087-.001-.001Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.024 274.632H17.39v10.783h117.634v-10.783Z",
    fill: "url(#b)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.254 285.415h-1.615a1.838 1.838 0 0 1-1.839-1.837v-8.946h3.454v10.783Z",
    fill: "url(#c)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.729 212.926c0-2.569-2.717-4.721-5.664-4.721H17.061c-2.947 0-5.282 2.152-5.282 4.721v58.455c0 2.569 2.335 4.761 5.282 4.761h111.004c2.947 0 5.664-2.191 5.664-4.761v-58.455Z",
    fill: "#606D80"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M129.844 215.282c0-2.351-2.028-4.273-4.807-4.273H20.319c-2.779 0-5.518 1.922-5.518 4.273v53.433c0 2.351 2.74 4.622 5.518 4.622h104.718c2.779 0 4.807-2.272 4.807-4.622v-53.433Z",
    fill: "#9CA6B5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m172.284 255.518-7.292-22.474c-.183-.564-.709-.899-1.303-.899h-29.313v53.27h39.634l-1.727-29.897h.001Z",
    fill: "#F87060"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M174.231 277.252c-.392-.258-.869-.397-1.416-.387l-30.546.588-.135 8.673 30.519.749c1.119 0 2.087-.539 2.087-1.295v-7.347c0-.369-.116-.723-.509-.981Z",
    fill: "url(#d)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m166.592 253.956-4.407-17.47c-.154-.607-.702-1.106-1.329-1.106h-17.238c-.37 0-.725.224-.982.489a1.454 1.454 0 0 0-.387 1.031l.414 13.986a1.378 1.378 0 0 0 1.151 1.32l21.232 3.432a1.368 1.368 0 0 0 1.546-1.683v.001Z",
    fill: "url(#e)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m165.712 235.244-.225.037a1.37 1.37 0 0 0-1.099 1.705l4.804 17.852a1.368 1.368 0 0 0 1.575.989l1.518-.284-6.573-20.3v.001Z",
    fill: "url(#f)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M149.27 256.731h-5.396c-.715 0-1.295.58-1.295 1.294v.647c0 .715.58 1.295 1.295 1.295h5.396c.715 0 1.295-.58 1.295-1.295v-.647c0-.714-.58-1.294-1.295-1.294Z",
    fill: "#F87060"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M136.42 216.414c-.46-.034-1.043.108-1.381.422-.338.314-.661.737-.661 1.197v14.111h17.875s-.96-14.646-15.832-15.73h-.001Z",
    fill: "#606D80"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M162.524 296.186c5.424-5.42 5.424-14.208 0-19.628-5.425-5.42-14.219-5.42-19.644 0-5.424 5.42-5.424 14.208 0 19.628 5.425 5.42 14.219 5.42 19.644 0Z",
    fill: "url(#g)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.72 297.455c6.13-1.111 10.198-6.977 9.087-13.103-1.112-6.125-6.983-10.19-13.113-9.079-6.13 1.111-10.198 6.977-9.086 13.102 1.111 6.126 6.982 10.191 13.112 9.08Z",
    fill: "#F87060"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M162.176 290.531a.274.274 0 0 1-.253-.382 9.625 9.625 0 0 0 .763-3.778c0-5.351-4.356-9.705-9.712-9.705a9.723 9.723 0 0 0-4.741 1.233.275.275 0 0 1-.269-.479 10.282 10.282 0 0 1 5.01-1.303c5.659 0 10.263 4.6 10.263 10.254 0 1.385-.271 2.728-.807 3.992a.274.274 0 0 1-.253.168h-.001Z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M157.718 287.681a5.17 5.17 0 0 0-3.71-6.301 5.169 5.169 0 1 0-2.596 10.008 5.175 5.175 0 0 0 6.306-3.707Z",
    fill: "url(#h)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.886 296.186c5.424-5.42 5.424-14.208 0-19.628s-14.219-5.42-19.643 0c-5.425 5.42-5.425 14.208 0 19.628 5.424 5.42 14.219 5.42 19.643 0Z",
    fill: "url(#i)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M68.879 297.492c6.15-.998 10.325-6.787 9.327-12.932-.998-6.145-6.792-10.318-12.942-9.32-6.15.997-10.326 6.787-9.327 12.932.998 6.145 6.792 10.317 12.942 9.32Z",
    fill: "#F87060"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M76.54 290.531a.274.274 0 0 1-.253-.382 9.636 9.636 0 0 0 .763-3.778c0-5.351-4.357-9.705-9.713-9.705a9.727 9.727 0 0 0-4.742 1.232.275.275 0 1 1-.269-.479 10.28 10.28 0 0 1 5.01-1.302c5.66 0 10.263 4.6 10.263 10.254 0 1.384-.27 2.727-.806 3.992a.275.275 0 0 1-.253.168Z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M71.992 287.954a5.168 5.168 0 0 0-3.348-6.5 5.168 5.168 0 1 0-3.158 9.845 5.174 5.174 0 0 0 6.506-3.345Z",
    fill: "url(#j)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.111 296.185c5.424-5.42 5.424-14.207 0-19.627-5.424-5.42-14.219-5.42-19.643 0-5.424 5.42-5.424 14.207 0 19.627 5.424 5.421 14.219 5.421 19.643 0Z",
    fill: "url(#k)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M37.105 297.493c6.15-.997 10.326-6.787 9.328-12.932-.998-6.145-6.793-10.318-12.942-9.32-6.15.997-10.326 6.787-9.328 12.932.998 6.145 6.793 10.318 12.942 9.32Z",
    fill: "#F87060"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M44.765 290.531a.27.27 0 0 1-.107-.023.273.273 0 0 1-.145-.359 9.637 9.637 0 0 0 .762-3.778c0-5.351-4.356-9.705-9.712-9.705a9.722 9.722 0 0 0-4.741 1.232.274.274 0 1 1-.269-.479 10.28 10.28 0 0 1 5.01-1.303c5.659 0 10.263 4.601 10.263 10.255 0 1.384-.271 2.727-.807 3.992a.276.276 0 0 1-.253.168Z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3 287.679a5.173 5.173 0 0 0-10.015-2.594 5.168 5.168 0 0 0 3.71 6.3 5.173 5.173 0 0 0 6.305-3.706Z",
    fill: "url(#l)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M169.203 269.025h3.517c.757 0 1.371.614 1.371 1.37v4.808c0 .757-.615 1.37-1.371 1.37h-3.517a1.371 1.371 0 0 1-1.371-1.37v-4.808c0-.757.615-1.37 1.371-1.37Z",
    fill: "url(#m)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M170.638 269.025v7.117h-1.127c-.756 0-1.679-.851-1.679-1.607v-4.507c0-.756.923-1.003 1.679-1.003h1.127Z",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M136.751 267.358a.275.275 0 0 1-.275-.275v-31.704a.275.275 0 1 1 .55 0v31.704a.275.275 0 0 1-.275.275Z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M148.972 230.712a.274.274 0 0 1-.259-.185c-4.105-11.883-12.574-11.042-12.66-11.033a.275.275 0 1 1-.064-.545c.088-.011 8.989-.919 13.244 11.399a.274.274 0 0 1-.261.364Z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M384.355 303.515c0 1.36-80.619 2.462-180.069 2.462-99.449 0-180.069-1.102-180.069-2.462s80.62-2.462 180.069-2.462c99.45 0 180.069 1.102 180.069 2.462Z",
    fill: "#C8D3DC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M247.417 34.788a.86.86 0 0 1-.841-.845c-.086-4.729-1.561-28.21-22.24-33.117-23.023-5.463-33.558 17.95-33.558 17.95S162.293 7.85 156.83 37.117c-17.86 4.287-22.501 27.607-10.884 39.01a9.985 9.985 0 0 0 6.902 2.858l111.855 1.007a7.365 7.365 0 0 0 7.126-5.267c3.494-11.793 8.074-39.175-24.416-39.935",
    fill: "#038FFD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M243.934 36.721a.828.828 0 0 1-.807-.81c-.088-4.357-1.491-25.274-20.207-29.653-20.918-4.9-30.491 16.1-30.491 16.1s-25.881-9.8-30.845 16.45c-16.073 3.807-20.363 24.367-10.189 34.693a9.6 9.6 0 0 0 6.754 2.861l101.181.9a7.077 7.077 0 0 0 6.853-5.075c3.153-10.76 6.897-34.77-22.249-35.466Z",
    fill: "#4FAFFA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.071 33.712c-.061.374-1.314 5.352 6.628 15.992s15.079 9.089 17.162 5.618c1.423-2.369 1.065-5.004 5.03-7.166 2.302-1.254 6.804-3.931 6.451-4.064-.526-.196-7.179 2-9.603 2.883-1.101.402-3.689 1.808-3.973 4.865-.544 5.844-8.584 2.207-12.906-5.103-2.123-3.59-3.631-7.364-4.356-12.37-.399-2.756-.859-3.092-2.468-2.414-.583.246-1.819.854-1.965 1.759Z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.894 43.223c-.294.424-.45.981-.347 1.627.178 1.123 1.147 2.645 3.604 5.14 0 0-.78-.458-1.083-.157-.372.368-.62 1.26-.104 1.844.687.778 2.208 1.675 5.111 3.246 1.354.733 6.019 2.926 3.902 4.51-1.001.749-1.604 1.143-1.604 1.143s5.752 4.9 13.808-1.638c0 0-6.824 2.05-14.796-6.846-3.131-3.494-5.176-6.61-6.373-8.498-.6-.946-1.158-1.752-2.118-.37ZM200.72 38.107c-.13 2.354.227 4.46 1.801 7.644 3.282 6.637 8.35 7.468 8.35 7.468s-3.375-2.341-5.366-7.468c-.806-2.078-1.531-4.84-1.588-7.862-.014-.736.255-2.988-1.678-2.15-1.132.49-1.432.784-1.519 2.368Z",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m290.348 176.986.363.344-.363-.343-27.309 28.927c-3.023 3.186-2.867 8.161.133 11.324l.001.001 27.174 28.926.001.002c6.344 6.688 9.365 15.565 9.365 24.824v20.391l-52.74 1.578-52.741-1.578v-20.391c0-9.239 3.53-18.124 9.888-24.824l27.43-28.928a8.227 8.227 0 0 0 .003-11.325l-27.435-28.928a36.05 36.05 0 0 1-9.886-24.824v-20.391l52.741-1.578 52.74 1.578v20.391c0 9.259-3.02 18.137-9.365 24.824Z",
    fill: "#A9D9FF",
    fillOpacity: 0.4,
    stroke: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M272.667 239.183s-14.163-10.02-16.295-26.405c2.132-16.386 16.295-26.406 16.295-26.406 34.211-23.516 21.425-52.562 21.425-52.562l-46.68-1.572-46.457 1.572s-12.674 29.048 21.538 52.562c0 0 14.259 10.02 16.404 26.406-2.145 16.385-16.404 26.405-16.404 26.405-34.212 23.516-21.538 52.562-21.538 52.562l46.457 1.57 46.68-1.57s12.785-29.048-21.425-52.562Z",
    fill: "url(#n)",
    fillOpacity: 0.65
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M237.623 191.149c3.432 2.242 6.018 5.361 7.412 9.214.092.254.178.688.256.936.311.981 1.223 1.831 2.253 1.831h.028c1.617 0 3.066-1.264 3.631-2.78 1.378-3.693 3.902-6.671 7.206-8.821 24.859-16.193 29.732-32.523 29.732-32.523h-80.09s4.851 15.995 29.575 32.141l-.003.002Z",
    fill: "url(#o)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M258.765 259.475c-3.414-2.227-6.052-5.588-7.528-9.386-.174-.448-.333-.955-.474-1.391-.342-1.071-1.34-1.829-2.465-1.829a3.997 3.997 0 0 0-3.76 2.603c-1.454 3.927-4.13 7.517-7.637 9.805-26.122 17.033-31.244 34.654-31.244 34.654h84.275s-5.112-17.452-31.167-34.455v-.001Z",
    fill: "url(#p)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M249.735 209.558a2.018 2.018 0 1 1-4.035-.001 2.018 2.018 0 0 1 4.035.001Z",
    fill: "url(#q)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M252.278 223.379a1.494 1.494 0 1 1-2.989 0 1.494 1.494 0 0 1 2.989 0Z",
    fill: "url(#r)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M246.299 234.139a1.494 1.494 0 1 1-2.988 0 1.494 1.494 0 0 1 2.988 0Z",
    fill: "url(#s)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M303.121 121.083H191.266c-4.075 0-7.378 2.169-7.378 4.844v.374c0 2.675 3.303 4.844 7.378 4.844h111.855c4.075 0 7.378-2.169 7.378-4.844v-.374c0-2.675-3.303-4.844-7.378-4.844Z",
    fill: "url(#t)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M303.121 291.966H191.266c-4.075 0-7.378 1.88-7.378 4.199v.323c0 2.319 3.303 4.199 7.378 4.199h111.855c4.075 0 7.378-1.88 7.378-4.199v-.323c0-2.319-3.303-4.199-7.378-4.199Z",
    fill: "url(#u)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m340.716 251.23-13.151-14.721-.135 17.896 3.957 11.479-39.334 6.82-1.666-31.036-2.833-23.837a6.465 6.465 0 0 1 4.054-6.783l10.825-4.262 15.246 2.796 6.131 2.333a16.823 16.823 0 0 1 6.685 4.646l18.464 21.114",
    fill: "#038FFD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M327.796 253.641c.092 0 .116-6.203.055-13.848-.061-7.65-.189-13.847-.281-13.847-.091 0-.116 6.197-.055 13.847.061 7.645.19 13.842.281 13.842v.006Z",
    fill: "#00679A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m326.356 258.196-23.769-9.567a5.432 5.432 0 0 1-3.389-4.622l-1.74-22.787s.207-9.69-5.85-10.16l-3.443 1.355c-4.451 2.363-5.55 8.841-4.946 13.848.861 7.107 1.221 17.17 2.186 23.336.788 5.05 3.682 9.489 8.621 10.789l29.271 6.338 3.059-8.524v-.006Z",
    fill: "#038FFD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M297.805 224.688s.037.177.073.519c.037.372.092.873.153 1.502.122 1.337.293 3.218.501 5.526.201 2.344.439 5.116.702 8.2.067.769.134 1.563.201 2.369.074.806.123 1.636.306 2.436.177.806.561 1.563 1.178 2.137.617.574 1.386 1.001 2.192 1.362 6.552 2.833 12.596 5.177 16.98 6.82l5.208 1.917c.593.22 1.063.391 1.417.519.324.122.488.189.488.201 0 .013-.177-.036-.506-.14-.354-.116-.831-.269-1.435-.464a245.998 245.998 0 0 1-5.245-1.826 297.59 297.59 0 0 1-17.035-6.74c-.818-.373-1.618-.806-2.278-1.423-.665-.611-1.092-1.453-1.27-2.296-.189-.842-.232-1.679-.305-2.485-.067-.806-.128-1.6-.189-2.369-.238-3.083-.452-5.861-.635-8.206-.171-2.314-.305-4.195-.403-5.532a203.81 203.81 0 0 0-.092-1.508c-.018-.342-.024-.525-.012-.525l.006.006ZM284.19 237.077s.024.103.049.305c.018.238.048.525.079.879.073.812.165 1.905.281 3.236.128 1.362.293 2.986.531 4.781.244 1.789.531 3.767 1.075 5.77.256 1.014.616 1.948 1.16 2.754a15.171 15.171 0 0 0 1.776 2.179c1.258 1.283 2.602 2.229 3.804 2.852 2.43 1.264 4.201 1.282 4.177 1.368 0 .012-.11.006-.312-.007a5.8 5.8 0 0 1-.879-.116c-.757-.134-1.85-.433-3.089-1.044-1.24-.61-2.62-1.551-3.908-2.845a16.156 16.156 0 0 1-1.826-2.21c-.568-.831-.952-1.826-1.209-2.839-.549-2.04-.83-4.018-1.056-5.819a101.823 101.823 0 0 1-.647-8.042 74.128 74.128 0 0 0-.019-.885c0-.201 0-.311.019-.311l-.006-.006Z",
    fill: "#00679A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M294.35 253.025c-.031-.006.067-.519.433-1.264.361-.745 1.026-1.716 1.997-2.546.971-.831 2.033-1.337 2.827-1.576.8-.244 1.313-.262 1.319-.232.012.055-.489.153-1.246.44a9.439 9.439 0 0 0-2.692 1.6 9.285 9.285 0 0 0-2.003 2.412c-.403.702-.58 1.178-.629 1.16l-.006.006Z",
    fill: "#00679A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M319.53 255.479c-2.54-1.435-5.025-2.54-7.687-3.749-2.656-1.209-5.257-2.76-6.997-5.104-3.279-4.421-2.906-10.801-6.264-15.167l.659 8.798c.201 2.687-.214 5.349 1.52 7.175 1.46 1.538 4.305 2.717 6.32 3.382 4.048 1.337 8.407 3.316 12.449 4.653",
    fill: "#000",
    opacity: 0.3
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M360.305 289.867s10.685 0 21.675 2.747c1.197.422 2.137 5.801-1.337 6.882-.879-.031-15.466.116-17.285 0-1.82-.116-5.801-3.218-5.801-3.218l2.748-6.411Z",
    fill: "#038FFD"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M378.403 253.33s6 2.012 6.019 8.335c.046 12.108-31.75 24.844-31.75 24.844l-28.966-21.003-2.173-.83s46.836-16.541 56.877-11.352l-.007.006Z",
    fill: "url(#v)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M343.875 276.557s.317-.19.848-.574c.538-.391 1.301-.965 2.235-1.686a185.873 185.873 0 0 0 7.15-5.843 186.167 186.167 0 0 0 6.857-6.185 90.22 90.22 0 0 0 2.002-1.954c.464-.47.715-.739.696-.751-.018-.018-.293.22-.787.66-.531.482-1.234 1.111-2.076 1.874a361.204 361.204 0 0 1-6.918 6.106 363.71 363.71 0 0 1-7.083 5.91c-.879.721-1.612 1.313-2.167 1.771-.513.421-.788.659-.77.678l.013-.006ZM369.603 257.965c.013-.08-1.447-.226-3.144.287-1.71.494-2.851 1.41-2.796 1.471.054.086 1.245-.671 2.894-1.148 1.642-.494 3.053-.5 3.053-.604l-.007-.006Z",
    fill: "#3E526F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M366.789 256.054c-.031-.08-1.075.384-1.936 1.459-.867 1.068-1.099 2.186-1.013 2.198.097.03.451-.983 1.276-1.991.812-1.013 1.728-1.581 1.679-1.666h-.006Z",
    fill: "#3E526F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M345.397 289.058c-.499.254-4.02 5.083-4.02 5.083s-5.187.919-7.022-3.053l5.97-5.408 5.072 3.378Z",
    fill: "url(#w)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m371.313 233.621-11.638 29.49-50.091.813-.922-2.705 17.554-.641 8.438-26.158 36.659-.799Z",
    fill: "#F87060"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M347.916 246.387c.641-.433 1.832-.262 2.412.257.58.519.763 1.416.47 2.137-.293.72-1.032 1.221-1.807 1.264-.824.043-1.685-.47-1.911-1.264-.226-.794.024-1.972.842-2.394",
    fill: "#EBEBEB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M350.272 292.133c.556.072 8.068 4.286 8.068 4.286s3.569-3.212 3.035-5.953l-7.14-3.588-3.962 5.251-.001.004Z",
    fill: "url(#x)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M357.251 288.035s-40.316-29.57-42.209-30.199c-1.886-.628-6.453-3.62-11.021-2.363-4.567 1.258-8.658 5.355-10.709 11.339-1.172 3.419-1.722 9.25-1.978 13.628-.312 5.233 1.306 10.447 4.732 14.416 1.557 1.807 3.474 3.376 5.751 4.084.483.147.977.281 1.49.391 8.725 1.893 17.695-2.027 22.591-9.488l1.075-1.636s25.833 5.782 26.31 5.629l3.968-5.801Z",
    fill: "url(#y)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M309.932 194.006s-3.263 5.725-7.632 12.822c0 0 5.083 4.538 8.243 5.19 2.727.563 7.327-2.442 7.327-2.442s-.524-3.143 2.442-10.075l-10.379-5.8-.001.305Z",
    fill: "url(#z)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M331.445 183.471s.163 6.872-3.092 16.583c.281-.858-2.87 8.814-8.966 6.82-6.093-1.994-9.336-7.344-9.36-13.607 0 0-.101-9.688 2.387-12.302 2.489-2.615 19.028 2.506 19.028 2.506h.003Z",
    fill: "url(#A)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m313.764 191.508.721.381s.228-7.708 3.395-7.405c3.168.3 14.6 3.643 18.752 1.126 4.001-2.425 4.481-8.041 2.285-10.847a.428.428 0 0 0-.581-.076l-.473.326a.438.438 0 0 1-.676-.45c.076-.368-.318-.663-.638-.473-1.259.745-4.039 1.565-9.474-.136-7.71-2.412-13.848-2-16.51 2.837-.168.305-.586.304-.767.001-.353-.594-1.106-1.183-2.706-.829-2.781.616-4.202 5.278-1.787 11.008.113.27-.052.586-.343.614-1.028.098-2.796.692-.665 3.856 2.18 3.237 4.065 4.008 4.833 4.19a.437.437 0 0 0 .503-.249l1.995-4.483a.437.437 0 0 1 .601-.211l1.535.813v.007Z",
    fill: "url(#B)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M313.567 192.463s1.695-6.731-2.131-6.468c-3.83.263-2.28 7.36-.084 8.706l2.219-2.238h-.004Z",
    fill: "url(#C)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m323.67 202.555-5.19-2.137c.204.712.977 2.32 2.443 3.053 1.465.732 2.442-.306 2.747-.916Z",
    fill: "#fff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m341.692 293.824-.009.012s-5.184 1.228-7.019-2.744l.829-.74c-.324-.113-.599-.179-.803-.179-2.625.001-6.484 1.467-6.484 1.467s-6.667 1.745-7.421 2.13c-3.32 1.287-1.09 6.348.751 6.021.333-.059 2.359-.187 4.83-.343 3.964-.249 9.073-.571 10.173-.798 1.786-.367 5.172-4.813 5.172-4.813l-.019-.013Z",
    fill: "#038FFD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M305.92 229.006a4.485 4.485 0 0 1-2.161-3.058c-.344-2.119-1.408-.259-.189 1.428 1.22 1.687 2.35 1.63 2.35 1.63",
    fill: "#fff",
    fillOpacity: 0.8
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M309.063 226.143s-2.554.766-2.534 2.472c.023 1.918-4.039-.188-4.425-2.405-.385-2.216-2.737-.947-.069 1.644 2.668 2.59 3.92 2.572 4.578 2.093 1.148-.836-.051-2.108 2.45-3.804",
    fill: "#fff",
    fillOpacity: 0.8
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M306.857 230.19s-1.902 1.128-4.513-1.529c-2.611-2.656-.723.747-.226.683.496-.064-1.715-.052 1.263.805 2.181.628.339.681.565 1.158.138.289 2.104.38 2.91-1.115",
    fill: "#fff",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 79.578,
    y1: 319.413,
    x2: 318.067,
    y2: 34.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E5FF",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAE9FF",
    stopOpacity: 0.57
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 84.49,
    y1: 273.599,
    x2: 83.972,
    y2: 292.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 16.77,
    y1: 273.599,
    x2: 7.506,
    y2: 283.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 160.733,
    y1: 275.906,
    x2: 159.134,
    y2: 292.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 156.158,
    y1: 233.437,
    x2: 147.846,
    y2: 266.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 168.873,
    y1: 233.269,
    x2: 151.622,
    y2: 255.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 142.381,
    y1: 273.295,
    x2: 163.839,
    y2: 313.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 146.925,
    y1: 284.134,
    x2: 161.435,
    y2: 293.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 56.744,
    y1: 273.295,
    x2: 78.201,
    y2: 313.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 61.417,
    y1: 283.803,
    x2: 75.4,
    y2: 293.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 24.969,
    y1: 273.295,
    x2: 46.426,
    y2: 313.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 29.508,
    y1: 284.132,
    x2: 44.017,
    y2: 293.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 151.261,
    y1: 288.507,
    x2: 212.475,
    y2: 254.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 198.66,
    y1: 212.778,
    x2: 296.431,
    y2: 212.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 202.264,
    y1: 203.283,
    x2: 254.671,
    y2: 118.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#038FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 199.568,
    y1: 294.094,
    x2: 255.797,
    y2: 204.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#038FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 235.018,
    y1: 217.954,
    x2: 270.729,
    y2: 194.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 241.378,
    y1: 229.598,
    x2: 267.827,
    y2: 212.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 235.399,
    y1: 240.358,
    x2: 261.848,
    y2: 222.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 256.108,
    y1: 120.119,
    x2: 255.689,
    y2: 137.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405470"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 256.108,
    y1: 291.131,
    x2: 255.793,
    y2: 306.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405470"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 357.406,
    y1: 249.04,
    x2: 347.912,
    y2: 306.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#102542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 342.584,
    y1: 291.138,
    x2: 332.446,
    y2: 289.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 351.676,
    y1: 294.447,
    x2: 360.53,
    y2: 289.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 328.918,
    y1: 250.891,
    x2: 313.714,
    y2: 324.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3D57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#102542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 315.433,
    y1: 196.387,
    x2: 302.318,
    y2: 224.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 333.003,
    y1: 190.85,
    x2: 310.986,
    y2: 195.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 319.324,
    y1: 170.291,
    x2: 326.297,
    y2: 208.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 333.761,
    y1: 186.194,
    x2: 309.89,
    y2: 191.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.048da2186d53a2b1978b40591df20c68.svg";
export { ForwardRef as ReactComponent };